var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"width":280,"color":"background"}},[_c('v-skeleton-loader',{staticClass:"mb-6",attrs:{"type":"card"}}),_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }